import React, { useRef, useState, useEffect } from 'react';
import { Flex } from 'theme-ui';

import SingleCard from '~/components/Content/Section/ContentCard/SingleCard';

const ContentSet = React.memo(function ContentSet({ contentCards }) {
  const [paused, setPaused] = useState(true);

  const leftRef = useRef(false);
  const rightRef = useRef(false);

  useEffect(() => {
    leftRef.current || rightRef.current ? setPaused(false) : setPaused(true);
  }, [paused, leftRef, rightRef]);

  return (
    <Flex
      sx={{
        flexDirection: ['column', 'row'],
        justifyContent: 'center',
        //flexWrap: !paused && 'wrap',
        columnGap: paused ? [null, '1rem', '2rem'] : 0,
        '.cardClass:first-of-type': {
          borderTopLeftRadius: [0, 2],
        },
        '.cardClass:last-of-type': {
          borderBottomRightRadius: [0, 4],
        },
        alignSelf: ['baseline'],
        rowGap: ['var(--gap)', null, '2rem'],
        '@supports not (gap: 10px) with (display: flex)': {
          display: 'grid',
          gridTemplateColumns: paused ? ['1fr', null, '1fr 1fr'] : '1fr',
        },
      }}
    >
      {contentCards.map((contentCard, index) => {
        const sideRef = index % 2 === 0 ? leftRef : rightRef;
        const margins =
          index % 2 === 0 ? ['0 1rem', '0 0 0 1rem', '0 0 0 2rem'] : ['0 1rem', '0 1rem 0 0', '0 2rem 0 0'];
        return contentCard.mainVideo ? (
          <SingleCard
            sideRef={sideRef}
            cardClass={'cardClass'}
            key={contentCard.id}
            contentCard={contentCard}
            outerPaused={paused}
            margins={!paused ? 0 : contentCard.fullWidth ? [0, margins] : margins}
            forwardSx={{ width: [null, '100%'] }}
            outerPausedFunc={setPaused}
          />
        ) : (
          <SingleCard
            cardClass={'cardClass'}
            key={contentCard.id}
            contentCard={contentCard}
            margins={!paused ? ['0 1rem', null, '0 2rem'] : contentCard.fullWidth ? [0, margins] : margins}
            forwardSx={{ width: [null, '100%'] }}
          />
        );
      })}
    </Flex>
  );
});

export default ContentSet;
